import { environment } from 'src/environments/environment';
import { EventEmitter, Output } from '@angular/core';
/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { AfterContentChecked, Component, Input, OnInit } from '@angular/core';
import { ListViewTypes } from '../listViewTypes';
import { TableColumnConfig } from '../table.columns';

declare function initSwiper(): void;
@Component({
  selector: 'app-notification-list',
  templateUrl: './notification-list.component.html'
})
export class NotificationListComponent implements OnInit {
  @Input() listViewTypes: ListViewTypes = ListViewTypes.table;
  @Input() emptyMessage: string;
  @Input() columnConfigs: TableColumnConfig[];
  @Input() items: any[];
  @Input() pageditems: any[];
  @Input() pageSize = environment.defaultPageSize;
  @Input() viewSearch = false;
  @Input() viewItemsCount = false;
  @Input() enableSelection = false;
  @Input() minCountToSearch = 5;
  @Input() loading = false;
  @Input() totalItemsCount = 0;
  @Input() pageNumber = 0;
  @Input() LazyLoading = true;
  @Input() showCursorOnRow: boolean=false;


  @Output() onPageChanged = new EventEmitter<any>();
  @Output() onSelectRow= new EventEmitter<any>();
  searchword: string;
  page1: any;
  constructor() {
  }

  ngOnInit(): void {
    this.searchword = '';
    var s = this.items;
    var con = this.columnConfigs;
  }

  changePage(event) {
    this.onPageChanged.emit(event);
  }
  selectRow(event: any) {
    this.onSelectRow.emit(event);
  }
}
